import { AdvancedFiltersMainWrapper, getUrlQueryParam, Product, standaloneExternalContext }
  from '@access-erp/common';
import { Toaster } from 'react-hot-toast';
import { useEffect, useState } from 'react';

import { EnquiriesApplicationModule } from '@/components/common/EnquiriesScreen/EnquiriesApplicationModule';
import { apolloClientContracts } from '@/apollo/clients/contracts.apollo';
import { ContractsExternalContext } from '@/components/common/EnquiriesScreen/utils/enquiriesSettings';
import BundlesComponent from './BundlesComponent';
import { getAccessToken } from '@/utils/auth/token.utils';
import { getSubscriptionId } from '@/utils/auth/subscription.utils';
import { appSettings } from '@/utils/microfrontend/appSettingsForEnquiriesScreen';

export default function BundlesModule(): React.JSX.Element {
  const [subscriptionId, setSubscriptionId] = useState<string>();

  useEffect(() => {
    const getSubId = async () => {
      const subId = await getSubscriptionId();
      setSubscriptionId(subId!);
    };

    getSubId();
  }, []);

  const externalContext: ContractsExternalContext = {
    ...standaloneExternalContext,
    product: Product.ContractsAndBilling,
    getIdentityToken: async () => getAccessToken(),
    refetchToken: async () => getUrlQueryParam('token') ?? '',
    getAccessWorkspaceInstanceId: () => subscriptionId!,
    preloadedData: {},
  };

  return (
    <EnquiriesApplicationModule
      externalContext={externalContext}
      appSettings={appSettings}
      pageName="Bundles"
      suppressIntercom={true}
      apolloClient={apolloClientContracts}>
      <AdvancedFiltersMainWrapper>
        <BundlesComponent />
        <Toaster />
      </AdvancedFiltersMainWrapper>
    </EnquiriesApplicationModule>
  );
}
